import PlusIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme,
  alpha,
  IconButton
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../core/hooks/useStore";
import { RootState } from "../../../core/store/store";
import KeywordPigHeaderCredits from "./keyword-pig-header-credits";
import toolsSlice from "./keyword-pig.slice";

const KeywordPigHeader = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const { apiUrl } = useSelector((state: RootState) => state.home);
  const toolsState = useSelector((state: RootState) => state.keywordPig);
  
  const handleOpen = () => {
    if (toolsState.tool.status === "initialized") {
      dispatch(toolsSlice.actions.setCreateDialogOpened(true));
    } else {
      dispatch(toolsSlice.actions.setStatus("initialized"));
      dispatch(toolsSlice.actions.setCreateDialogOpened(true));
    }
  };

  const handleBackClick = () => {
    if (["created", "creating"].includes(toolsState.tool.status)) {
      dispatch(toolsSlice.actions.setStatus("initialized"));
      dispatch(toolsSlice.actions.setData(null));
      navigate("/tools/keyword-tool");
    } else {
      navigate("/tools");
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Stack 
        direction="row" 
        justifyContent="space-between" 
        alignItems="flex-start" 
        sx={{ mb: 3 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <IconButton
            onClick={handleBackClick}
            aria-label="Go back to tools"
            sx={{
              border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              bgcolor: 'white',
              '&:hover': {
                bgcolor: alpha(theme.palette.primary.main, 0.05),
                borderColor: theme.palette.primary.main
              }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          
          <Box>
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 700,
                mb: 1
              }}
            >
              Keyword Pig Pro
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Discover high-intent keywords to boost your content visibility
            </Typography>
          </Box>
        </Box>
        
        <Stack direction="row" spacing={2} alignItems="center">
          <KeywordPigHeaderCredits />
          
          {["initialized", "created"].includes(toolsState.tool.status) && (
            <Button
              onClick={handleOpen}
              size="large"
              startIcon={<PlusIcon />}
              variant="contained"
              sx={{ 
                px: 3,
                minWidth: 140,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                '&:hover': {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                }
              }}
            >
              New Search
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default KeywordPigHeader;
